import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IncompleteWorkComponent } from "./incomplete-work.component";

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        IncompleteWorkComponent,
    ],
    declarations: [
        IncompleteWorkComponent,
    ],
})

export class AdaptIncompleteWorkModule {
}
